<template>
  <section class="ct-media-feed">
    <div class="ct-media-feed__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <VueCarousel
          v-if="slice?.FeedDisplay?.Display === 'Slider'"
          v-bind="sliderSettings"
          ref="carousel"
          class="ct-media-feed__slider"
        >
          <VueSlide
            v-for="data in slice.Files"
            :key="data"
          >
            <StrapiMedia
              class="ct-media-feed__media"
              :media="data"
              :lazy="index > 0"
              :banner-count="slice?.Files?.length"
              :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
            />
          </VueSlide>

          <template #addons>
            <div
              v-if="showNavigation"
              class="carousel__navigation"
            >
              <VueNavigation>
                <template #prev>
                  <IconArrow class="carousel__icon icon icon--arrow icon--arrow-left" />
                </template>
                <template #next>
                  <IconArrow class="carousel__icon icon icon--arrow icon--arrow-right" />
                </template>
              </VueNavigation>
            </div>
          </template>
        </VueCarousel>

        <ul
          v-else-if="slice?.FeedDisplay?.Display === 'Grid'"
          class="ct-media-feed__grid"
          :style="`--columns: ${slice?.Files?.length};`"
        >
          <li
            v-for="data in slice.Files"
            :key="data"
            class="ct-media-feed__grid-item"
          >
            <StrapiMedia
              :class="['ct-media-feed__media', { 'media--hero': slice?.Files?.length === 1 && slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width' }]"
              :media="data"
              :lazy="index > 0"
              :banner-count="slice?.Files?.length"
              :full-width="slice?.Settings?.SliceWidth?.toLowerCase() === 'full_width'"
            />
          </li>
        </ul>
      </div>
    </div>

    <!--  -->
    <!--  -->
  </section>
</template>

<script lang="ts" setup>
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const { settings } = useSliderSettings()
const sliderSettings = Object.assign({}, settings, {
  itemsToShow: 1.5,
  breakpoints: {
    700: {
      itemsToShow: 3,
      itemsToScroll: 3,
    },
    1024: {
      itemsToShow: 4,
      itemsToScroll: 4,
    },
  },
})

const carousel = ref()
const showNavigation = computed(() => {
  return props.slice?.Files?.length > carousel.value?.data?.config?.itemsToShow
  // return carousel.value?.data?.slidesCount.value > carousel.value?.data?.config?.itemsToShow
})
</script>

<style>
@import url("~layers/app/assets/css/vue3-carousel-nuxt.css");
@import url("~layers/app/components/Slices/MediaFeed.css");
</style>
